import React, { Component } from "react";
import { connect } from 'react-redux';
import SeoHeaders from "./seoheaders";
import {FormattedMessage} from "react-intl";
import * as wActs from "../actions/website-actions";
import SwBanner from "./swbanner";
import RightBanners from "./rightbanners";

class NotFound extends Component {

  render() {
    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    return (

      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>
        <div className={`cell ${showBan ? "x9" : "x12"}`}>
          <div className="white-wrap the-content">



            <div className="row m-t-xl">
              <div className="col_25" id={"noresultsimg"}>
                <img src={"/imgs/no-results-img.jpg"} width={"200"} height={"200"} alt={""}/>
              </div>
              <div className="col_75" id={"noresults"}>
                <h4><FormattedMessage id={"page.404.pagenotfound"} >{(...content) => content}</FormattedMessage></h4>
                <div style={{color: '#454545', fontSize: "13px"}} dangerouslySetInnerHTML={{__html: this.props.Content.Main}}></div>
              </div>
              <div className="col_100" style={{height: '500px'}}>
                &nbsp;
              </div>
            </div>



          </div>
        </div>

        {showBan &&
        <div className="cell x3">
          <RightBanners/>
        </div>
        }


      </div>


    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Content: state.Website.Page.Content,
    HtmlSections: state.Website.Settings.HtmlSections
  };
}

export default connect(mapStateToProps)(NotFound);
